import type { SVGProps } from "react";

// Small stroke icons (16px grid), hand-drawn to avoid an icon dependency.
const PATHS: Record<string, string> = {
  board: "M2.5 3h3v10h-3zM6.5 3h3v7h-3zM10.5 3h3v5h-3z",
  inbox: "M2 9h3.5l1 2h3l1-2H14M2 9l2-5.5h8L14 9v4H2z",
  settings:
    "M8 10.2a2.2 2.2 0 1 0 0-4.4 2.2 2.2 0 0 0 0 4.4zM13 8l1.3-1-1.2-2.2-1.6.4a5 5 0 0 0-1.2-.7L10 2.9H6l-.3 1.6a5 5 0 0 0-1.2.7l-1.6-.4L1.7 7 3 8l-1.3 1 1.2 2.2 1.6-.4c.4.3.8.5 1.2.7L6 13.1h4l.3-1.6c.4-.2.8-.4 1.2-.7l1.6.4L14.3 9z",
  bell: "M4 11V7a4 4 0 0 1 8 0v4l1.2 1.5H2.8zM6.5 13.5a1.6 1.6 0 0 0 3 0",
  plus: "M8 3v10M3 8h10",
  x: "M4 4l8 8M12 4l-8 8",
  check: "M3 8.5l3 3 7-7",
  chevronRight: "M6 3.5L10.5 8 6 12.5",
  chevronDown: "M3.5 6L8 10.5 12.5 6",
  comment: "M2.5 3h11v7.5H7L4 13v-2.5H2.5z",
  arrowRight: "M2.5 8h10M9 4.5L12.5 8 9 11.5",
  arrowLeft: "M13.5 8h-10M7 4.5L3.5 8 7 11.5",
  play: "M5 3.5v9l7-4.5z",
  stop: "M4 4h8v8H4z",
  pause: "M5 3.5v9M11 3.5v9",
  bot: "M4 6h8v6.5H4zM8 3.5V6M6 9h.01M10 9h.01M2.5 8.5v2M13.5 8.5v2",
  user: "M8 8a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5zM3 13.5c.6-2.3 2.6-3.5 5-3.5s4.4 1.2 5 3.5",
  alert: "M8 2.5l6 10.5H2zM8 6.5v3M8 11.5h.01",
  question: "M6 6a2 2 0 1 1 2.8 1.8c-.5.3-.8.7-.8 1.2v.5M8 12h.01M8 14.5A6.5 6.5 0 1 0 8 1.5a6.5 6.5 0 0 0 0 13z",
  pr: "M4.5 3.5v9M4.5 3.5a1.3 1.3 0 1 0 0 .01M4.5 12.5a1.3 1.3 0 1 0 0 .01M11.5 12.5V6.5a2 2 0 0 0-2-2H7.5M9 3l-1.5 1.5L9 6M11.5 12.5a1.3 1.3 0 1 0 0 .01",
  merge: "M4.5 3.5v9M4.5 5.5c0 3 3 4 7 4M11.5 9.5a1.3 1.3 0 1 0 0 .01M4.5 3.5a1.3 1.3 0 1 0 0 .01M4.5 12.5a1.3 1.3 0 1 0 0 .01",
  server: "M2.5 3h11v4h-11zM2.5 9h11v4h-11zM5 5h.01M5 11h.01",
  eye: "M1.5 8S4 3.5 8 3.5 14.5 8 14.5 8 12 12.5 8 12.5 1.5 8 1.5 8zM8 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4z",
  flag: "M3.5 14V2.5M3.5 3h8l-1.5 3 1.5 3h-8",
  lightbulb: "M6 12.5h4M6.5 14.5h3M8 1.5a4.5 4.5 0 0 0-2.5 8.2V11h5V9.7A4.5 4.5 0 0 0 8 1.5z",
  pencil: "M10.5 2.5l3 3L6 13H3v-3z",
  dot: "M8 9.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z",
  gate: "M3 13.5V5l5-2.5L13 5v8.5M6 13.5V9h4v4.5",
  paperclip: "M13 7.5l-5.3 5.3a3 3 0 0 1-4.3-4.3l5.6-5.6a2 2 0 0 1 2.9 2.9L6.3 11.4a1 1 0 0 1-1.4-1.4L10 4.9",
  file: "M4 1.5h5.5L12.5 4.5v10h-8.5zM9.5 1.5v3h3",
  external: "M9 2.5h4.5V7M13.5 2.5L7.5 8.5M12 9.5v4H2.5V4h4",
  menu: "M2.5 4h11M2.5 8h11M2.5 12h11",
  refresh: "M13 3.5v3h-3M3 12.5v-3h3M12.6 6.5A5 5 0 0 0 3.6 5M3.4 9.5a5 5 0 0 0 9 1.5",
  history: "M2.5 8a5.5 5.5 0 1 0 1.6-3.9M2.5 2.5v2.5H5M8 5v3l2 1.5",
  trash: "M3 4.5h10M6.5 4.5V3h3v1.5M4.5 4.5l.6 9h5.8l.6-9",
  up: "M8 13V3M4 7l4-4 4 4",
  down: "M8 3v10M4 9l4 4 4-4",
  terminal: "M2.5 3h11v10h-11zM5 6.5l2 1.5-2 1.5M8.5 10H11",
  logout: "M6 2.5H3v11h3M10 5l3 3-3 3M13 8H6",
};

export type IconName = keyof typeof PATHS;

export function Icon({
  name,
  size = 16,
  ...rest
}: { name: IconName; size?: number } & Omit<SVGProps<SVGSVGElement>, "name">) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.4}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      className="icon"
      {...rest}
    >
      <path d={PATHS[name]} />
    </svg>
  );
}
